import { heroPoints } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="relative w-full pt-28 md:pt-32 pb-14 md:pb-20 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-[460px] bg-gradient-to-b from-primary-50 via-accent-50/50 to-transparent pointer-events-none"></div>

      <div className="relative w-full max-w-site mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="animate-fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-200 bg-primary-50 text-primary-700 text-xs md:text-sm font-medium">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-line"></i>
              </span>
              评论 · 关注 · 私信，一站打通
            </div>

            <h2 className="mt-5 font-heading text-3xl md:text-[42px] md:leading-[1.22] font-bold text-foreground-950">
              把评论区、关注动态和私信，收进同一个页面
            </h2>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              黑料社区的用户互动功能全部开放：在评论区内直接对线，关注后追踪发帖动态，私信沟通线索与求证。粉丝互动氛围活跃，爆料人、围观群众都在这里交换看法，讨论留下的每一条痕迹都能被追回来。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#download"
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium inline-flex items-center justify-center gap-2 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-download-2-line text-base"></i>
                免费下载客户端
              </a>
              <a
                href="#topics"
                className="h-11 px-6 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-medium inline-flex items-center justify-center gap-2 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                先逛逛话题广场
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>

            <ul className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2.5">
              {heroPoints.map((point) => (
                <li
                  key={point}
                  className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600"
                >
                  <span className="w-4 h-4 flex items-center justify-center text-secondary-600">
                    <i className="ri-check-line"></i>
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          <div className="animate-fade-up delay-200 relative">
            <div className="w-full h-[320px] md:h-[500px] rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20flat%20illustration%20of%20overlapping%20chat%20bubbles%2C%20hashtag%20tags%20and%20comment%20cards%20floating%20in%20warm%20amber%2C%20coral%20and%20cream%20tones%2C%20clean%20minimalist%20editorial%20composition%2C%20soft%20grain%20texture%2C%20calm%20neutral%20cream%20background%2C%20high%20detail&width=1000&height=1150&seq=hlzt-hero-01&orientation=portrait"
                alt="黑料社区互动界面示意，评论区、关注与私信话题标签墙"
                title="黑料社区 - 用户评论互动 关注粉丝私信交流"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute bottom-4 left-4 right-4 md:left-5 md:right-auto flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-background-50/95 border border-background-200 text-xs text-foreground-800">
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-live-line"></i>
                </span>
                12,486 人在线
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-background-50/95 border border-background-200 text-xs text-foreground-800">
                <span className="w-4 h-4 flex items-center justify-center text-accent-600">
                  <i className="ri-mail-send-line"></i>
                </span>
                私信平均 6 分钟回复
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}